import React from 'react';

const TimeLine = ({ activeTimeLine, handleActiveTimeLine }) => {
    let activeBorder = '2px solid #121180';
    return (
        <div className="timeline timeline-3 py-13">
            <div className="d-flex align-items-center justify-content-center timeline-items">
                <div className="timeline-item">
                    <div className={"timeline-media cursor-pointer " + ((activeTimeLine === 'title') ? 'bg-primary text-white' : '')} style={{border: (activeTimeLine === 'title') ? activeBorder : ''}} onClick={() => handleActiveTimeLine('title')}>
                        Title
                    </div>
                </div>
                <div className="timeline-item">
                    <div className={"timeline-media cursor-pointer " + ((activeTimeLine === 'body') ? 'bg-primary text-white' : '')} style={{border: (activeTimeLine === 'body') ? activeBorder : ''}} onClick={() => handleActiveTimeLine('body')}>
                        Body
                    </div>
                </div>
                <div className="timeline-item">
                    <div className={"timeline-media cursor-pointer " + ((activeTimeLine === 'service') ? 'bg-primary text-white' : '')} style={{border: (activeTimeLine === 'service') ? activeBorder : ''}} onClick={() => handleActiveTimeLine('service')}>
                        Service
                    </div>
                </div>
                <div className="timeline-item">
                    <div className={"timeline-media cursor-pointer " + ((activeTimeLine === 'workflow') ? 'bg-primary text-white' : '')} style={{border: (activeTimeLine === 'workflow') ? activeBorder : ''}} onClick={() => handleActiveTimeLine('workflow')}>
                        Workflow
                    </div>
                </div>
                <div className="timeline-item">
                    <div className={"timeline-media cursor-pointer " + ((activeTimeLine === 'preview') ? 'bg-primary text-white' : '')} style={{border: (activeTimeLine === 'preview') ? activeBorder : ''}} onClick={() => handleActiveTimeLine('preview')}>
                        Preview
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TimeLine;